<template>
  <!-- <div class="viewer" :id='viewer'>
         <img src='$factoryLink' /> 
    </div> -->
  <div id="main">
    <!-- <img src='../../../assets/quanjing.jpg'/> -->
    <div id="viewer1" v-show="this.pshow">
      <!-- <h2 style="text-align: center">欢迎来到服务厅全景图</h2>
      <p style="font-size: 16px; margin: 0px; padding: 0px">目前经纬度</p>
      <div style="float: left">
        <p style="font-size: 12px; margin: 0px; padding: 0px">经度：</p>
        <span style="font-size: 12px; float: left" id="long"></span>
      </div>
      <div style="float: right">
        <p style="font-size: 12px; margin: 0px; padding: 0px">纬度：</p>
        <span style="font-size: 12px" id="lat"></span>
      </div> -->
      <!-- <button @click="initPhotoSphere">显示全景图</button> -->
    </div>

    <div class="views_img">
      <div class="views_box" @click="getViews">
        <img
          src="../../../assets/video.png"
          alt=""
          v-if="voice"
          @click="playAudio()"
        />
        <img
          src="../../../assets/noVideo.png"
          alt=""
          v-else
          @click="noPlayAudio()"
        />
      </div>
      <audio
        :src="vrAudio"
        id="eventAudio"
        preload="auto"
        controls
        loop
        hidden="true"
      ></audio>

      <div class="views_box" @click="getImgs">
        <img src="../../../assets/imgs.png" alt="" />
      </div>
    </div>

    <div class="allImgs flex" v-if="allImgsShow">
      <div
        class="allImgs_box_imgs"
        v-for="(items, index) in vrList"
        :key="index"
        @click="getVrImage(index)"
      >
        <img :src="items.list[0].url" alt="" />
        <p>{{ items.name }}</p>
      </div>
    </div>
    <div class="allImgs2 flex" v-if="allImgsShow2">
      <div
        class="allImgs_box_imgs"
        v-for="(items, index) in vrList[vrImageIndex].list"
        :key="index"
        @click="getVrImage2(items.url)"
      >
        <img :src="items.url" alt="" />
        <!-- <p>{{ items.name }}</p> -->
      </div>
    </div>

    <div class="allImgs_top" v-if="allImgsTopShow">
      <div class="allImgs_box_imgs" @click="getAllTopImgs">
        <img src="" alt="" />
        <p>图片名称</p>
      </div>
    </div>
  </div>
</template>

<script>
// import PhotoSphereViewer from 'photo-sphere-viewer'
import { getParkDetail } from "../../../utils/interface";
import { Viewer } from "photo-sphere-viewer";
import MarkersPlugins from "photo-sphere-viewer/dist/plugins/markers";
import AutorotateKeypointsPlugin from "photo-sphere-viewer/dist/plugins/autorotate-keypoints";
import "photo-sphere-viewer/dist/photo-sphere-viewer.css";
import { mapMutations, mapState } from "vuex";

// import * as Three from 'three'

//     var THREE   = require('three');
//     var PhotoSphereViewer   = require('photo-sphere-viewer');
export default {
  data() {
    return {
      beginToSpin: 0, // 刷新页面，开始旋转 0:初始化  1:刚开始， 2:首次旋转经度大于1,
      isbeginToSpin: true,
      vrImageUrl: "",
      vrAudio: "",
      vrIndex: 0, //初始角标为 0
      viewers: null, // 创建VR实例
      pshow: true,
      use: true,
      psv: "",
      id: "",
      vrImage: "",
      vrList: [],
      vrImageIndex: "0",
      readyLoad: "",
      imageLoaded: "",
      longitude: "", //目前经度
      latitude: "", //目前纬度
      marker3: require("../../../assets/logo.png"),
      imageloading: [
        {
          marker: [
            {
              id: "image1",
              //   image: require("../../../assets/pin1.png"),
              width: 35,
              height: 35,
              longitude: 10,
              latitude: 100,
              anchor: "bottom center",
              className: "markers",
              //   tooltip: {
              //     content: "欢迎进入下一场景",
              //     position: "bottom left",
              //   },
              visible: true,
            },
          ],
        },
      ],
      voice: true,
      allImgsShow: false,
      allImgsTopShow: false,
      allImgsShow2: false,
      parkHeight: "",
      setIn: null,
      vrImgsOne: "",
      vrImgsList: [],
    };
  },
  created() {
    this.id = this.$route.params.uuid;
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getParkDetail();
      }
    }, 500);
    this.vuexAllPark(false);
    this.parkHeight = document.documentElement.clientHeight;
    console.log(this.parkHeight);
  },
  mounted() {
    // markersPlugin.on("select-marker", (e, marker) => {
    //   console.log(marker.id);
    //   const markerid = marker.id;
    // });
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  methods: {
    ...mapMutations(["vuexAllPark"]),
    playAudio() {
      let buttonAudio = document.getElementById("eventAudio");
      buttonAudio.play();
    },

    noPlayAudio() {
      let buttonAudio = document.getElementById("eventAudio");
      buttonAudio.pause()();
    },

    getParkDetail() {
      getParkDetail(this.id).then((res) => {
        let vvvvitems = [];
        // this.vrImage = res.vrImage;
        this.vrList = res.vrGroupList;
        this.vrList.forEach((items, index) => {
          // console.log(items.list)
          items.list.forEach((items, index) => {
            // console.log(items.url);
            vvvvitems.push(items.url);
          });
        });
        this.vrImgsList = vvvvitems;
        console.log(this.vrImgsList)
        this.vrAudio = res.vrAudioUrl;
        this.vrImageUrl = this.vrList[0].list[0].url;
        this.initPhotoSphere();
      });
    },
    getVrImage(i) {
      this.allImgsShow2 = true;
      this.vrImageIndex = i;
    },
    getVrImage2(url) {
      this.vrImageUrl = url;
      this.initPhotoSphere();
    },

    initPhotoSphere(temp_img) {
      let that = this;
      document.getElementById("viewer1").innerHTML = "";

      this.viewers = new Viewer({
        // Container 容器
        container: document.getElementById("viewer1"),
        // Panorama, given in base 64
        // 全景的图片
        panorama: this.vrImageUrl,
        fisheye: true,
        autorotateDelay: "1000",
        defaultZoomLvl: "1",
        defaultLat: "-1.5",
        autorotateLat: "0",

        useXmpData: true,
        sphereCorrection: {
          pan: 30,
          tilt: 0,
          roll: 0,
        },
        // autoload:true,
        // mousewheel: false,
        // // Deactivate the animation
        // time_anim: false, // 在多少毫秒内开始自动播放
        autorotateSpeed: "1rpm", // 自动旋转速度， 默认是2rpm

        // loading_img: this.img,
        //enabled: 'false',
        // caption: "珠海移动营业厅", // 给图片加说明
        // Display the navigation bar
        navbar: true,
        // time_anim: true,
        // navbar: [
        //   {
        //     id: "my-button", //按钮的唯一标识符，在使用该navbar.getButton()方法时很有用
        //     content: "Custom", //必需的,按钮内容
        //     title: "Hello world", //鼠标悬停在按钮上时显示工具提示
        //     className: "custom-button", //CSS类已添加到按钮
        //     onClick: () => {
        //       console.log(33333) //必需的,单击按钮时调用的函数
        //     },
        //     //disabled:false,最初禁用该按钮
        //     //hidden:false,最初隐藏按钮
        //   },
        // ],
        size: {
          width: "100%",
          height: that.parkHeight + "px",
        },
        // plugins: [[AutorotateKeypointsPlugin]],
      });
      // this.viewers = viewers;
      this.viewers.on("autorotate", (e, enabled) => {
        // debugger

        if (enabled == true) {
          console.log(enabled);

          this.viewers.on("position-updated", (e, position) => {
            // console.log(
            //   enabled,
            //   `-0000000new position is longitude: ${position.longitude} latitude: ${position.latitude}`
            // );
            if (position.longitude === 0 && that.beginToSpin === 0) {
              // 刚进来
              console.log("开始");
              that.beginToSpin = 1;
            }

            if (that.beginToSpin === 1 && position.longitude > 3) {
              // 已经开始旋转
              if (that.isbeginToSpin === true) {
                that.isbeginToSpin = false;
                that.beginToSpin = 2;
                console.log(111111)
                // setTimeout(function (params) {
                //   console.log(
                //     `new position is longitude: ${position.longitude} latitude: ${position.latitude}`
                //   );
                // }, 30000);
              }
            }
            if (
              that.beginToSpin === 2 &&
              0 < position.longitude &&
              position.longitude < 1
            ) {
              console.log(
                `-2222new position is longitude: ${position.longitude} latitude: ${position.latitude}`
              );
              that.beginToSpin = 0;
              let imageIndex = 1;
              that.vrImageUrl = that.vrImgsList[imageIndex++];
              console.log("cccc", imageIndex);
              that.initPhotoSphere();
              console.log("---------转了一圈");
            }
          });
        }
      });
      // this.viewers.on("position-updated", (e, position) => {
      //   // 可以获取到当前的经纬度，可以用于测试时获取经纬度
      //   // if(position.longitude < 1) {
      //   //   console.log(`new position is longitude: ${position.longitude}`)
      //   // }
      //   // console.log(that.enableds)
      //   if (
      //     position.longitude === 0 &&
      //     position.latitude === -1.5 &&
      //     that.beginToSpin === 0
      //   ) {
      //     // 刚进来
      //     console.log("开始");
      //     that.beginToSpin = 1;
      //   }

      //   if (that.beginToSpin === 1 && position.longitude > 3) {
      //     // 已经开始旋转
      //     if (that.isbeginToSpin === true) {
      //       that.isbeginToSpin = false;
      //       setTimeout(function (params) {
      //         console.log(
      //           `new position is longitude: ${position.longitude} latitude: ${position.latitude}`
      //         );
      //         that.beginToSpin = 2;
      //       }, 30000);
      //     }
      //   }
      //   if (
      //     that.beginToSpin === 2 &&
      //     0 < position.longitude &&
      //     position.longitude < 1
      //   ) {
      //     console.log(
      //       `new position is longitude: ${position.longitude} latitude: ${position.latitude}`
      //     );
      //     that.beginToSpin = 0;
      //     // debugger
      //     this.viewers.setPanorama(that.vrImageIndex, true, true).then(() => {
      //       that.isbeginToSpin = true;
      //       console.log("-------替换图片完成--------");
      //     });

      //     // that.vrImageUrl =
      //     //   that.vrList[that.vrImageIndex++].list[that.vrImageIndex++].url;
      //     that.initPhotoSphere();
      //     console.log("---------转了一圈");
      //   }
      // });
      const markersPlugin = viewers.getPlugin(MarkersPlugins);
    },

    isMobile() {
      let ua = navigator.userAgent;

      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;
      return isMobile;
    },
    getViews() {
      this.voice = !this.voice;
    },
    getImgs() {
      this.allImgsShow = !this.allImgsShow;
      if (this.allImgsShow2) {
        this.allImgsShow2 = false;
      }
      if (this.allImgsShow == false) {
        this.allImgsTopShow = false;
      }
    },

    // getAllImgs(url) {
    //   this.allImgsTopShow = true;
    //   console.log(url);
    //   this.vrImageUrl = url;
    // },
    // 点击切换大图的展示
    getAllTopImgs() {
      console.log("打印");
      this.viewers.setPanorama(this.vrImageUrl).then(() => {
        console.log("-------替换图片完成--------");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.hi {
  color: red;
  font-size: 20px;
  text-align: left;
}
#main {
  position: relative;
  /deep/ .psv-container {
    height: 100% !important;
  }
  /deep/ .psv-markers-list-button {
    display: none;
  }
  .views_img {
    position: absolute;
    top: 1rem;
    right: 1rem;
    .views_box {
      width: 2rem;
      height: 2rem;
      background: rgba(0, 0, 0, 0.221);
      border-radius: 50%;
      padding: 0.5rem;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .views_box:nth-child(1) {
      margin-bottom: 0.5rem;
    }
  }
}
.allImgs {
  background: rgba(0, 0, 0, 0.221);
  width: 100%;
  height: 70px;
  padding: 20px 0;
  position: absolute;
  bottom: 40px;
  justify-content: center;
  .allImgs_box_imgs {
    width: 80px;
    height: 80px;
    background: #fff;
    position: relative;
    margin-right: 34px;
    // margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      background: rgba(0, 0, 0, 0.221);
      font-size: 13px;
      color: #fff;
    }
  }
}
.allImgs2 {
  justify-content: center;
  background: rgba(0, 0, 0, 0.221);
  width: 100%;
  height: 70px;
  padding: 20px 0;
  position: absolute;
  bottom: 160px;

  .allImgs_box_imgs {
    width: 80px;
    height: 80px;
    background: #fff;
    position: relative;
    margin-right: 34px;
    // margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      background: rgba(0, 0, 0, 0.221);
      font-size: 13px;
      color: #fff;
    }
  }
}
.allImgs_top {
  background: rgba(0, 0, 0, 0.221);
  width: 100%;
  height: 100px;
  padding: 20px 0;
  position: absolute;
  bottom: 200px;
  .allImgs_box_imgs {
    width: 100px;
    height: 100px;
    background: #fff;
    position: relative;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      background: rgba(0, 0, 0, 0.221);
      font-size: 13px;
      color: #fff;
    }
  }
}
</style>
   


// WEBPACK FOOTER //
// src/components/park/allMap/veiws.vue